import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { moduloAPI } from '../lib/api';

const moduleRoutes = {
    guias_despacho: '/guias/dashboard',
    ordenes_servicio: '/ordenes/dashboard',
    alarmas_ls: '/alarmas/panel',
    integrador_codelco: '/codelco/dashboard',
    solicitudes_permisos: '/solicitudes/dashboard',
};

export default function HomePage() {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [checked, setChecked] = useState(false);

    const resolveRedirect = useCallback(async () => {
        try {
            const modulosRes = await moduloAPI.getEmpresa();
            const empresaModules = modulosRes.data.map(m => m.codigo);

            const userAllowed = user?.modulos_acceso?.length > 0 ? user.modulos_acceso : null;
            const available = userAllowed
                ? empresaModules.filter(c => userAllowed.includes(c))
                : empresaModules;

            if (available.length === 0) {
                setChecked(true);
                return;
            }

            const principal = user?.modulo_principal;
            let target = null;

            if (principal && available.includes(principal)) {
                target = moduleRoutes[principal];
            } else if (available.length === 1) {
                target = moduleRoutes[available[0]];
            } else {
                target = moduleRoutes[available[0]];
            }

            if (target) {
                navigate(target, { replace: true });
            } else {
                setChecked(true);
            }
        } catch {
            setChecked(true);
        }
    }, [user, navigate]);

    useEffect(() => {
        if (user) resolveRedirect();
    }, [user, resolveRedirect]);

    if (!checked) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
            <div className="text-center space-y-4">
                <h2 className="font-heading text-2xl font-bold">Sin módulos disponibles</h2>
                <p className="text-muted-foreground text-sm">
                    No tienes módulos asignados. Contacta al administrador.
                </p>
            </div>
        </div>
    );
}
